import './Footer.css'

const Footer = () => <footer className='footer' />

export default Footer
